/**
2  *  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
3  *
4  * THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
5  * AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
6  * WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
7  * TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
8  * AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
9  * INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
10  * PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
11  * CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
12  * OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
13  * ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
14  * THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
15  */

import { Component } from '@angular/core';
import { UserProfileResponse } from './userprofileresponse';
import { UserProfileService } from './userprofile.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'zsd-userprofile',
  templateUrl: './userprofile.component.html',
  styleUrls: ['./userprofile.component.scss']
})
export class UserProfileComponent {

  ldap = true;
  success: boolean;
  successMessage = 'Your profile has been updated successfully.';
  failureMessage = 'Failed to update your profile';
  pwdEmptyMessage = 'Password is empty.';
  confirmPwdEmptyMessage  = 'Confirm your password.';

  // Profile Heading
  profileHeader = 'My Profile';

  // labels for UI
  usernameLabel = 'Username:';
  passwordLabel = 'Password:';
  confirmPasswordLabel = 'Confirm Password:';
  emailLabel = 'Email:';

  // textfield contents for UI
  username: string;
  password: string;
  confirmPassword: string;
  email: string;

  // button values for UI
  cancelButton = 'Cancel';
  saveButton = 'Save';
  okButton = 'OK';

  // error messages for input field
  usernameRequiredError = 'Username is required.';
  passwordRequiredError = 'Password is required';
  confirmPasswordRequiredError = 'Confirm Password is required';
  passwordsMismatchError = 'Passwords do not match.';
  emailRequiredError = 'Email is required.';
  emailInvalidError = 'Invalid email';

  userProfileForm: FormGroup;
  usernameFocus: boolean;
  passwordFocus = true;
  emailFocus: boolean;
  confirmPasswordFocus = false;
  confirmPasswordError = false;
  disabled = true;

  successResponse;
  failureResponse;
  pwdEmptyResponse;
  confirmPwdEmptyResponse;

  userProfile: UserProfileResponse = new UserProfileResponse();

  constructor(private userprofileservice: UserProfileService, public formBuilder: FormBuilder) {
    this.userProfileForm = formBuilder.group({
      username: this.formBuilder.control({ value: ''}),
      password: this.formBuilder.control({ value: '', disabled: this.ldap }),
      cnf_password: this.formBuilder.control({ value: '', disabled: this.ldap }),
      email: this.formBuilder.control({ value: '', disabled: this.ldap }, [Validators.email, Validators.required])
    });
    // fetching user details
    this.userprofileservice.getUserprofile().subscribe(
      (userProfile: UserProfileResponse) => {
        this.userProfile = userProfile;
        this.ldap = this.userprofileservice.isLDAP(userProfile);

        // setting password to 'password' and disabling input fields for LDAP users
        if (this.ldap) {
          this.userProfile.password = this.confirmPassword = 'password';
        } else {
          this.userProfile.password = this.confirmPassword = '';
          this.userProfileForm.enable();
        }
        this.userProfileForm.get('username').disable();
        this.userProfileForm.get('username').setValue(this.userProfile.username);
        this.userProfileForm.get('email').setValue(this.userProfile.email);
        this.userProfileForm.updateValueAndValidity();

      },
      err => console.error(err)
    );
  }
  passwordValidation(): boolean {
    // false if password matches for local user, true otherwise
    if (this.confirmPassword === this.password && this.confirmPassword !== '') {
      return false;
    } else {
      return true;
    }
  }
  emailValidation(): boolean {
    // false if email is valid, true otherwise
    if (this.userProfileForm.get('email').valid || this.userProfileForm.get('email').value === '') {
      return false;
    } else {
      return true;
    }
  }
  emailEmpty(): boolean {
    return this.userProfileForm.get('email').value === '';
  }
  validateSave() {
    if ((this.password === '' || this.password == null) && (this.confirmPassword === '' || this.confirmPassword == null)) {
      return true;
    } else {
      if (this.userProfileForm.valid && this.password === this.confirmPassword) {
        return true;
      } else {
        return false;
      }
    }
  }
  passwordEmptyValue() {
    return (this.password !== '' && this.password != null) ;
  }
  confirmPasswordEmptyValue() {
    return (this.confirmPassword == null || this.confirmPassword === '');
  }
  updateProfile(): void {
    const username = this.userProfileForm.controls.username.value;
    const password = this.userProfileForm.controls.password.value;
    const email = this.userProfileForm.controls.email.value;
    if (password) {
      if (this.userProfileForm.valid && !this.passwordValidation() && !this.emailValidation()) {
        this.userprofileservice.updateProfile(username, password, email).subscribe(
          (usreProfile: UserProfileResponse) => {
            if (usreProfile.success) {
              this.successResponse = this.successMessage;
              this.password = null;
              this.confirmPassword = null;
            }
          },
          err => {
            const error = err.error;
            console.error(error);
            this.failureResponse = this.failureMessage;
          }
        );
      }
    } else {
      if (!this.emailValidation()) {
        this.userprofileservice.updateProfile(username, password, email).subscribe(
          (usreProfile: UserProfileResponse) => {
            if (usreProfile.success) {
              this.successResponse = this.successMessage;
              this.password = null;
              this.confirmPassword = null;
            }
          },
          err => {
            const error = err.error;
            console.error(error);
            this.failureResponse = this.failureMessage;
          }
        );
      }
    }
  }
}
